import {
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
    AfterViewChecked,
    AfterViewInit,
    AfterContentInit,
    Input,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from 'app/navigation/navigation';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { locale as english } from '../../../navigation/i18n/en';
import { locale as spanish } from '../../../navigation/i18n/es';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ToolbarComponent implements OnInit, OnDestroy {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    fuseConfig: any;
    data: any;
    selectedOption = '';
    app_route = '';
    // selected: any;
    // ruta: any;
    // tipo_consulta: string = '';

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _fuseTranslation: FuseTranslationLoaderService,
        private _translateService: TranslateService,
        private dom: DomSanitizer,
        private router: Router
    ) {
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50',
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107',
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336',
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD',
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161',
            },
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'us',
            },
            {
                id: 'es',
                title: 'Spanish',
                flag: 'es',
            },
        ];

        this.navigation = navigation;
        this.data = {
            image: 'assets/images/avatars/profile.jpg',
        };

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.router.events.forEach((event) => {
            // Esto sucede cuando cambiamos de History a otra ruta cualquiera
            if (event instanceof NavigationEnd) {
                this.ngOnInit();
                // const view_id = params[5];
                // this.tipo_consulta = params[6];
                // this.ruta = params[5];
                // if (!params.includes('portal')) {
                //     this.selectedOption = 'none';
                // }
                // if (
                //     view_id === 'listar_ordenes_medicas' ||
                //     view_id === 'ordenes_medicas_hospitalizacion' ||
                //     view_id === 'ordenes_medicas_hospitalizacion_editar' ||
                //     view_id === 'ordenes_medicas_dieta' ||
                //     view_id === 'ordenes_medicas_dieta_editar' ||
                //     view_id === 'ordenes_medicas_mezclas' ||
                //     view_id === 'ordenes_medicas_mezclas_editar' ||
                //     view_id === 'ordenes_medicas_tratamiento' ||
                //     view_id === 'ordenes_medicas_tratamiento_editar' ||
                //     view_id === 'ordenes_medicas_laboratorio' ||
                //     view_id === 'ordenes_medicas_laboratorio_editar' ||
                //     view_id === 'ordenes_medicas_imagenes' ||
                //     view_id === 'ordenes_medicas_imagenes_editar' ||
                //     view_id === 'ordenes_medicas_cirugia' ||
                //     view_id === 'ordenes_medicas_cirugia_editar' ||
                //     view_id === 'ordenes_medicas_interconsulta' ||
                //     view_id === 'ordenes_medicas_interconsulta_editar' ||
                //     view_id === 'ordenes_medicas_posicion' ||
                //     view_id === 'ordenes_medicas_posicion_editar' ||
                //     view_id === 'ordenes_medicas_otros' ||
                //     view_id === 'ordenes_medicas_otros_editar'
                // ) {
                //     this.selected = 'listar_ordenes_medicas';
                // } else {
                //     this.selected = view_id;
                // }
            }
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this._fuseTranslation.loadTranslations(english, spanish);
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.fuseConfig = settings;
                this.data.image = this.dom.bypassSecurityTrustUrl(
                    settings.user.image
                );
                this.horizontalNavbar =
                    settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {
            id: this._translateService.currentLang,
        });

        const params = window.location.hash.split('/');
        this.menuOptionSelected(params);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void {
        // Do your search here...
        // console.log(value);
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);

        // Set selected language on localStorage
        localStorage.setItem('language', lang.id);
    }

    changeContent(content): void {
        const params = window.location.hash.split('/');

        const paciente_id = params[3];
        const cita_id = params[4];
        const consulta_id = params[6];
        const om_id = params[7];
        this.router.navigate([
            'medic/history/' +
                paciente_id +
                '/' +
                cita_id +
                '/' +
                content +
                '/' +
                consulta_id +
                '/' +
                om_id,
        ]);
    }

    changeSrc(e: any): void {
        const nodes = e.target.firstChild.children;
        const src = nodes[0].src;

        if (src.includes('gris') && !src.includes(this.selectedOption)) {
            e.target.firstChild.firstChild.src = src.replace('gris', 'color');
            e.target.firstChild.children[1].style.height = '3px';
        } else if (!src.includes(this.selectedOption)) {
            e.target.firstChild.firstChild.src = src.replace('color', 'gris');
            e.target.firstChild.children[1].style.height = '0';
        }
    }

    menuOptionSelected(url_params: string[]): void {
        if (this.app_route) {
        }

        switch (url_params[1]) {
            case 'portal':
                this.app_route = 'portal';
                break;

            case 'pacientes':
                this.app_route = 'pacientes';
                switch (url_params[2]) {
                    case 'home':
                        this.selectedOption = 'home';
                        break;
                    case 'calendario':
                        this.selectedOption = 'atender';
                        break;
                    case 'informes':
                        this.selectedOption = 'informe';
                        break;
                }
                break;

            case 'auth':
                switch (url_params[2]) {
                    case 'login':
                        this.selectedOption = 'home';
                        break;
                    case 'patient_login':
                        this.app_route = 'pacientes';
                        break;
                }
                break;

            default:
                this.app_route = 'portal';
                break;
        }
    }
}
